import { useCallback, useSyncExternalStore } from "react";
const TIER_MIN_WIDTH = {
  wide: 1440,
  desktop: 1280,
  laptop: 1024,
  tablet: 768,
  phone: 0
};
function tierForWidth(width) {
  if (width >= TIER_MIN_WIDTH.wide) return "wide";
  if (width >= TIER_MIN_WIDTH.desktop) return "desktop";
  if (width >= TIER_MIN_WIDTH.laptop) return "laptop";
  if (width >= TIER_MIN_WIDTH.tablet) return "tablet";
  return "phone";
}
const listPaneIsDrawer = (tier) => tier === "laptop" || tier === "tablet" || tier === "phone";
const rightPanelIsOverlay = (tier) => tier !== "wide";
function useShellTier(ref, forced) {
  const subscribe = useCallback(
    (onChange) => {
      const element = ref.current;
      if (!element || typeof ResizeObserver === "undefined") return () => void 0;
      const observer = new ResizeObserver(onChange);
      observer.observe(element);
      return () => {
        observer.disconnect();
      };
    },
    [ref]
  );
  const getSnapshot = () => {
    const element = ref.current;
    if (!element) return "wide";
    const measured2 = element.getBoundingClientRect().width;
    const width = measured2 > 0 ? measured2 : element.ownerDocument.defaultView?.innerWidth ?? TIER_MIN_WIDTH.wide;
    return tierForWidth(width);
  };
  const measured = useSyncExternalStore(subscribe, getSnapshot, () => "wide");
  return forced ?? measured;
}
export {
  TIER_MIN_WIDTH,
  listPaneIsDrawer,
  rightPanelIsOverlay,
  tierForWidth,
  useShellTier
};
//# sourceMappingURL=layout.js.map